export const SENDING_REQUEST = 'TEMPLATEBUILDER_SENDING_REQUEST';
export const GET_CLASSIFIERS = 'TEMPLATEBUILDER_GET_CLASSIFIERS';
export const GET_TEMPLATES = 'TEMPLATEBUILDER_GET_TEMPLATES';
export const SET_TEMPLATE = 'TEMPLATEBUILDER_SET_TEMPLATE';
export const FAILURE = 'TEMPLATEBUILDER_FAILURE';
export const RESET_FORM = 'TEMPLATEBUILDER_RESET_FORM';